import { cn } from "../../utils";

interface TypingIndicatorProps {
	/** "user" = slate (ユーザー側), "assistant" = emerald (AI側) */
	variant?: "user" | "assistant";
}

/**
 * TypingIndicator - バウンスするドットアニメーション
 * サジェストボタン押下後、LLMがクエリ生成中に表示
 */
export function TypingIndicator({ variant = "user" }: TypingIndicatorProps) {
	const dotColor = variant === "assistant" ? "bg-emerald-400" : "bg-slate-400";
	
	return (
		<span className="inline-flex items-center gap-1.5">
			<span className={cn("typing-dot h-2 w-2 rounded-full", dotColor)} style={{ animationDelay: "0s" }} />
			<span className={cn("typing-dot h-2 w-2 rounded-full", dotColor)} style={{ animationDelay: "0.2s" }} />
			<span className={cn("typing-dot h-2 w-2 rounded-full", dotColor)} style={{ animationDelay: "0.4s" }} />
		</span>
	);
}

